import { combineReducers } from 'redux';
import h5Christmas from './h5-christmas';
import h5Baby from './h5-baby';
import base from './base';
import h5Olympic from './h5-olympic';
import ganPlay from './h5-gan';
export default combineReducers({ h5Christmas, base, h5Baby, olympic: h5Olympic, ganPlay });
